export default __webpack_public_path__ + "static/media/g.8dfbc988.jpg";